// src/components/ServiceNow/TaskCardList.jsx
import React from "react";
import { Box, Alert } from "@mui/material";
import TaskCard from "./TaskCard";
import { getValue } from "../../utils/serviceNowUtils"; // Add this import

const TaskCardList = ({
  tasks,
  selectedTasks,
  onTaskSelection,
  onTaskUpdate,
  onAddComment,
  taskStates,
  allExpanded,
}) => {
  if (!tasks || tasks.length === 0) {
    return (
      <Alert
        severity="info"
        sx={{
          mt: 2,
          fontFamily: "Urbanist, Verdana, Arial, sans-serif",
        }}
      >
        No tasks found for this RITM
      </Alert>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {tasks.map((task) => {
        const taskSysId = getValue(task.sys_id) || task.sys_id;
        return (
          <TaskCard
            key={taskSysId}
            task={task}
            isSelected={selectedTasks.includes(taskSysId)}
            onSelection={onTaskSelection}
            onUpdate={onTaskUpdate}
            onAddComment={onAddComment}
            taskStates={taskStates}
            forceExpanded={allExpanded}
          />
        );
      })}
    </Box>
  );
};

export default TaskCardList;
